import Quill from 'quill';
import ReactQuill from "react-quill";
import BetterTable from 'quill-better-table';
import 'quill-better-table/dist/quill-better-table.css';
import styled from 'styled-components';

Quill.register({
  'modules/better-table': BetterTable,
});

const ReactQuillStyled = styled(ReactQuill)`
  .ql-editor li {
    list-style-type: unset !important;
  }
`

/*
const CustomToolbar = () => (
  <div id="toolbar">
    <select className="ql-header" defaultValue={""} onChange={e => e.persist()}>
      <option value="1" />
      <option value="2" />
      <option selected />
    </select>
    <button className="ql-bold" />
    <button className="ql-italic" />
    <button className="ql-underline" />
    <button className="ql-insertStar">
      <span>foo</span>
    </button>
  </div>
);
*/

const Editor = ({value, onChange}: any) => {
  // Is alignment allowed in toolbar
  //const alignment =[{ align: [] }];

   // Toolbar modules
   const modules = {
    toolbar: [
      [{ header: 1 }, { header: 2 }],
      ['bold', 'italic', 'underline'],
      //[{ script: 'sub' }, { script: 'super' }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      //sizes,
      //colors,
      [{ indent: '-1' }, { indent: '+1' }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      //links,
      [<button className="ql-insertStar"><span className="octicon octicon-star">foo</span></button>]
      ['clean']
    ].filter(obj => obj) // remove null elements
  };

  /*
  // Toolbar formats
  const format = [
    'header',
    'size',
    'bold',
    'italic',
    'underline',
    'list',
    'bullet',
    'indent',
    'link',
    'color'
  ];
  */



  return (<ReactQuillStyled
            
                style={{ width: '100%', height: '50em', paddingBottom: '3em', marginBottom: '2em', backgroundColor: 'white' }}
                modules={modules}
                onChange={(newValue) => onChange(newValue)}
                readOnly={false}
                value={value}
                 />)
}

export default Editor;